import { useEffect, useState } from "react";
import { Award, PartyPopper, MessageSquare, ListChecks } from "lucide-react";
import { http, errMsg } from "../api";
import Stepper from "../components/creator/Stepper";
import OnboardingChat from "../components/creator/OnboardingChat";
import ProfileStep from "../components/creator/ProfileStep";
import LanguageTest from "../components/creator/LanguageTest";
import ListeningTest from "../components/creator/ListeningTest";
import AgreementsStep from "../components/creator/AgreementsStep";

export default function CreatorJourney() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState(0);
  const [view, setView] = useState(null);
  const [error, setError] = useState("");

  const load = (advance = false) => http.get("/creator/me")
    .then(r => { setData(r.data); setActive(a => (advance || !a) ? r.data.progress.current_step : a); setView(v => v || (r.data.progress.onboarding_done ? "steps" : "chat")); })
    .catch(e => setError(errMsg(e)));
  useEffect(() => { load(); }, []);

  if (error) return <div className="notice error" data-testid="creator-journey-error">{error}</div>;
  if (!data) return <div className="loading">Loading your application…</div>;
  const { profile, progress } = data;
  const step = progress.steps.find(s => s.n === active) || progress.steps[0];

  return (
    <>
      <div className="page-head">
        <div><h1>Hiring Journey</h1><p>AI Audiobook Creator · Chat with the assistant, then complete the hiring steps to get shortlisted.</p></div>
        <div className="page-head-side">
          {progress.shortlisted && <span className="badge success" data-testid="shortlisted-badge"><Award size={12} /> Shortlisted</span>}
          {progress.onboarding_done && (view === "chat"
            ? <button className="ghost" onClick={() => setView("steps")} data-testid="open-steps"><ListChecks size={14} /> My hiring steps</button>
            : <button className="ghost" onClick={() => setView("chat")} data-testid="open-chat"><MessageSquare size={14} /> Chat with assistant</button>)}
        </div>
      </div>
      {view === "chat" ? (
        <OnboardingChat onCompleted={() => load(true)} onGoToSteps={() => { setView("steps"); load(true); }} />
      ) : (
        <>
          {progress.shortlisted && (
            <div className="shortlist-banner" data-testid="shortlist-banner">
              <PartyPopper size={24} />
              <div>
                <strong>Congratulations, {profile.name}! You are shortlisted.</strong>
                <p>{progress.agreements_done ? "Your agreements are signed — the Vocalhouse team will contact you with training details." : "Next: sign the NDA and Freelancer agreement in Step 4. The team will also reach you on " + profile.phone + "."}</p>
              </div>
            </div>
          )}
          <Stepper steps={progress.steps} active={active} onSelect={setActive} />
          {step.status === "locked" ? <div className="empty" data-testid="step-locked">Complete the previous step to unlock this one.</div> : (
            <>
              {active === 1 && <ProfileStep profile={profile} languages={data.config.regional_languages} onSaved={() => load(true)} />}
              {active === 2 && <LanguageTest onChanged={() => load(false)} />}
              {active === 3 && <ListeningTest onChanged={() => load(false)} />}
              {active === 4 && <AgreementsStep onChanged={() => load(false)} />}
            </>
          )}
        </>
      )}
    </>
  );
}
